module.exports = __webpack_public_path__ + "img/submit.d6b87f1a.svg";